import styled from 'styled-components'

import { TextField } from '@loadsmart/miranda-react'

/**
 * The segmented control that groups the report catalog by product. It sticks
 * to the top of the scrolling content so the whole catalog stays one click
 * away however far down the list you are.
 */
export const StyledToolbar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: var(--m-spacing-2);
  padding: 5px;
  /* Sits just inside the 8px radius of the tab pills it wraps. */
  border-radius: 10px;
  background-color: rgb(var(--m-color-background-primary));
  border: var(--m-border-thin) solid rgb(var(--m-color-border));
  box-shadow: 0 4px 14px rgba(var(--m-color-neutral-100), 0.05);
`

export const StyledTabList = styled.div`
  display: flex;
  align-items: center;
  gap: var(--m-spacing-1);
  min-width: 0;
  flex-wrap: wrap;
`

export const StyledTab = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--m-spacing-2);
  padding: var(--m-spacing-2) var(--m-spacing-4);
  border: none;
  border-radius: var(--m-border-radius-m);
  cursor: pointer;
  font-family: var(--m-font-family-default);
  font-size: var(--m-font-size-3);
  font-weight: var(--m-font-weight-medium);
  white-space: nowrap;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  background-color: ${({ $active }) =>
    $active ? 'rgb(var(--m-color-primary-100))' : 'transparent'};
  color: ${({ $active }) =>
    $active ? 'rgb(var(--m-color-text-inverted))' : 'rgb(var(--m-color-text-secondary))'};

  &:hover {
    background-color: ${({ $active }) =>
      $active ? 'rgb(var(--m-color-primary-100))' : 'rgb(var(--m-color-background-secondary))'};
  }
`

/**
 * The per-tab report count. It answers "is there anything for me in here?"
 * without opening the tab, so it is part of the label rather than decoration.
 */
export const StyledTabCount = styled.span<{ $active: boolean }>`
  font-size: var(--m-font-size-2);
  font-weight: var(--m-font-weight-bold);
  line-height: var(--m-line-height-4);
  border-radius: 999px;
  padding: 0 var(--m-spacing-2);

  background-color: ${({ $active }) =>
    $active ? 'rgba(var(--m-color-neutral-0), 0.2)' : 'rgba(var(--m-color-neutral-100), 0.08)'};
  color: ${({ $active }) =>
    $active ? 'rgb(var(--m-color-text-inverted))' : 'rgb(var(--m-color-text-secondary))'};
`

// Pushes the search field to the trailing edge of the bar.
export const StyledSpacer = styled.span`
  flex: 1;
`

export const StyledSearchField = styled(TextField)`
  width: 240px;
  flex: 0 0 auto;
`

export const StyledVisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
